"use strict";
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSS = void 0;
var theme_1 = require("../theme");
var theme_palette_1 = require("../theme.palette");
exports.CSS = {
    alertHref: 'c-Page__licenseBannerAlertHref',
    closeButton: 'c-Page__licenseBannerCloseButton',
    alert: 'c-Page__licenseBannerAlert',
    closeIcon: 'c-Page__LicenseBannerCloseIcon',
    License: 'c-Page__LicenseTextItem'
};
var alertHeightDesktop = 62;
var alertHeightLaptop = 60;
var alertHeightMobile = 84;
var Style = (_a = {},
    _a[exports.CSS.closeButton] = (_b = {
            position: 'absolute',
            right: theme_1.DefaultTheme.space(1),
            color: theme_palette_1.ColorPalette2022Branding.darkGray,
            background: 'none',
            padding: theme_1.DefaultTheme.space(1.5),
            border: "1px solid ".concat(theme_palette_1.ColorPalette2022Branding.darkGray),
            borderRadius: '2px',
            display: 'flex',
            alignItems: 'center',
            cursor: 'pointer',
            transition: 'all 0.15s ease'
        },
        _b['&:hover'] = {
            color: theme_palette_1.ColorPalette2022Branding.g11,
            borderColor: theme_palette_1.ColorPalette2022Branding.g11
        },
        _b),
    _a[exports.CSS.alertHref] = (_c = {
            textDecoration: 'underline',
            color: theme_palette_1.ColorPalette2022Branding.lightIndigo
        },
        _c['&:hover'] = {
            color: theme_palette_1.ColorPalette2022Branding.lightGray
        },
        _c),
    _a[exports.CSS.alert] = (_d = {
            height: "".concat(alertHeightDesktop, "px"),
            backgroundColor: theme_palette_1.ColorPalette2022Branding.ikeOrange,
            color: theme_palette_1.ColorPalette2022Branding.darkGray,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            boxSizing: 'border-box',
            padding: '0 12px'
        },
        _d['@media only screen and (max-width: 1200px)'] = {
            height: "".concat(alertHeightLaptop, "px")
        },
        _d['@media only screen and (max-width: 700px)'] = {
            height: "".concat(alertHeightMobile, "px")
        },
        _d),
    _a["".concat(exports.CSS.alert, " a")] = {
        transition: 'color 0.15s ease'
    },
    _a[exports.CSS.closeIcon] = {
        fontSize: '16px'
    },
    _a[exports.CSS.License] = {
        'padding-right': '70px'
    },
    _a);
(0, theme_1.addStyles)(Style);
//# sourceMappingURL=license.banner.style.js.map